import { render, staticRenderFns } from "./YourPromotionalUpsells.vue?vue&type=template&id=619b84f8"
import script from "./YourPromotionalUpsells.vue?vue&type=script&lang=js"
export * from "./YourPromotionalUpsells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports